export default __webpack_public_path__ + "static/media/SuisseIntl-Regular.a50708c6.otf";